import { render, staticRenderFns } from "./Slides.vue?vue&type=template&id=7b5f1491&"
import script from "./Slides.vue?vue&type=script&lang=js&"
export * from "./Slides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/casperjureskog/CMM/creo-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b5f1491')) {
      api.createRecord('7b5f1491', component.options)
    } else {
      api.reload('7b5f1491', component.options)
    }
    module.hot.accept("./Slides.vue?vue&type=template&id=7b5f1491&", function () {
      api.rerender('7b5f1491', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/asset/Slides.vue"
export default component.exports